const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Compact relative time for list rows and message stamps. Hand-rolled rather
 * than `date-fns`: this is the only formatting the widget does, and the visitor
 * pays for anything it imports.
 */
export const formatRelativeTime = (value: string): string => {
  const timestamp = Date.parse(value);

  if (Number.isNaN(timestamp)) {
    return '';
  }

  const elapsed = Date.now() - timestamp;

  if (elapsed < MINUTE) {
    return 'just now';
  }

  if (elapsed < HOUR) {
    return `${Math.floor(elapsed / MINUTE)}m ago`;
  }

  if (elapsed < DAY) {
    return `${Math.floor(elapsed / HOUR)}h ago`;
  }

  if (elapsed < 7 * DAY) {
    return `${Math.floor(elapsed / DAY)}d ago`;
  }

  return new Date(timestamp).toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
};

/** Status values arrive as the API's raw enum names (`IN_PROGRESS`). */
export const formatStatus = (status: string): string => status
  .toLowerCase()
  .split('_')
  .filter(Boolean)
  .join(' ');

const KILOBYTE = 1024;
const MEGABYTE = KILOBYTE * KILOBYTE;

/** A file's size as a person reads it: `812 KB`, `2.4 MB`. */
export const formatFileSize = (bytes: number): string => {
  if (bytes < KILOBYTE) {
    return `${bytes} B`;
  }

  if (bytes < MEGABYTE) {
    return `${Math.round(bytes / KILOBYTE)} KB`;
  }

  return `${(bytes / MEGABYTE).toFixed(1)} MB`;
};
